<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="epigraph1">I am not I;</p>
<p class="noind">he is not he;</p>
<p class="noind">they are not they.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-epigraph1.vue?312c0a59